<div class="lds-ring" [ngStyle]="{ width: size, height: size, color: color }">
	<div [ngStyle]="{ 'border-width': thickness, width: size, height: size }"></div>
	<div [ngStyle]="{ 'border-width': thickness, width: size, height: size }"></div>
	<div [ngStyle]="{ 'border-width': thickness, width: size, height: size }"></div>
	<div [ngStyle]="{ 'border-width': thickness, width: size, height: size }"></div>
</div>
